import { render } from "./AppSelectElement.vue?vue&type=template&id=d630cc5e"
import script from "./AppSelectElement.vue?vue&type=script&lang=js"
export * from "./AppSelectElement.vue?vue&type=script&lang=js"
script.render = render

export default script